<script setup>
import { Card, Label, Input, Checkbox, Button, Icon, Modal, MediaUploaderButton, Tabs, Tab, Toggle, TimePicker, Dropdown, ProfilePicture } from '@components'
import { ref, reactive, computed, onMounted } from 'vue'
import { getPrice } from '@utils'
import CustomSchedule from './CustomSchedule.vue'


// Route.
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()

// Staff Store.
import { useStaff } from '@store/staff.js'
const $staff = useStaff()

// Customer
import { useCustomer } from '@store/customer.js'
const $customer = useCustomer()

// Appointment
import { useAppointment } from '@store/appointment'
const $appointment = useAppointment()

// Service.
import { useService } from '@store/service'
const $service = useService()

import { useSettings } from '@store/settings.js'
const $settings = useSettings()


const staffId = computed(() => {
    return route.params.staffId
})

// const $settings = prebook_admin.settings || {}

// State.
const state = reactive({})

const staff = ref({
    meta: {},
    services: [],
    working_hours: {},
    days_off: []
})

const deleteStaff = async (staff) => {
    const response = await staff.delete()

    if (response.success) {
        Toast.success(`${$settings.labels.staff?.singular} deleted successfully`)
        $staff.fetchData()
        router.push({ name: 'staff.list' })
    } else {
        // Toast.error(response.message)
    }
}



onMounted(async () => {
    // Loading.
    state.loading = true
    $appointment.fetchData()
    $service.fetchData()
    $customer.fetchCustomers()

    // Fetch staff.
    staff.value = await $staff.fetchStaffs(staffId.value)
    Log('STAFF', staff.value)

    // await $service.fetchData()
    state.loading = false
})


const isCustomPrice = ref(false)

const save = async () => {
    state.saving = true

    const response = await $staff.updateStaff(staff.value)
    Log('RESPONSE', response)

    state.saving = false

    if (!response.success) {
        Toast.error(response.message || 'Something went wrong')
    } else {
        Toast.success(`${$settings.labels.staff?.singular} updated successfully`)
    }
}


const updateServices = async () => {
    await save()
    isCustomPrice.value = false
}

const sortCategory = computed(() => {
    return $service.getCategories.sort((a, b) => a.meta.priority - b.meta.priority)
})

const getCategories = computed(() => {
    const cats = sortCategory.value
    const services = $service.getServices

    if (!cats || !services) return []

    const _cats = cats.map(cat => {
        let _services = services.filter(service => service.category_id == cat.category_id)
        _services = _services.sort((a, b) => a.meta.order - b.meta.order).filter(service => service.status === 'publish')

        return {
            category_id: cat.category_id,
            name: cat.name,
            services: _services.map(service => {
                return {
                    service_id: service.service_id,
                    name: service.name,
                    price: service.meta.price,
                }
            }),
        }
    })

    return _cats.filter(cat => cat.services.length)
})

const isCatSelected = (category_id) => {
    // Return true if all services of this category is selected, return -1 if some services are selected, return false if no service is selected
    const services = getCategories.value.find(cat => cat.category_id == category_id)?.services
    if (!services) return false

    if (0 == staff.value.services?.length) return false

    const selectedServices = services.filter(service => staff.value.services.includes(service.service_id))
    if (selectedServices.length == services.length) return true

    if (selectedServices.length > 0) return -1

    return false
}

const isServiceSelected = (service_id) => {
    if (!staff.value.services || !staff.value.services.length) return false
    return staff.value.services.includes(service_id)
}

const selectCat = (category_id) => {
    const services = getCategories.value.find(cat => cat.category_id == category_id)?.services
    if (!services) return

    const selectedServices = services.filter(service => staff.value.services.includes(service.service_id))
    if (selectedServices.length == services.length) {
        // Unselect all services
        services.forEach(service => {
            service.meta = {
                checkbox: false,
            }
            staff.value.services = staff.value.services.filter(id => id !== service.service_id)
        })
    } else {
        // Select all services
        services.forEach(service => {
            service.meta = {
                checkbox: true,
            }
            staff.value.services.push(service.service_id)
        })
    }
}

const selectService = (service_id) => {
    // If service is already selected, remove it from staff services array
    if (staff.value.services.includes(service_id)) {
        staff.value.services = staff.value.services.filter(id => id !== service_id)
        return
    }

    // Add service id in staff services array
    staff.value.services.push(service_id)
}
import moment from "moment"

const isCustomSchedule = ref(false)

const isScheduleEnabled = (value) => {
    return [true, 'true', 1, '1', 'yes'].includes(value)
}
const toggleSchedule = (day) => {
    staff.value.working_hours[day].enabled = isScheduleEnabled(staff.value.working_hours[day].enabled) ? false : true

    if (staff.value.working_hours[day].enabled) {
        staff.value.working_hours[day].hours = staff.value.working_hours[day].hours || []
        if (staff.value.working_hours[day].hours.length == 0) {

            const newSlot = {
                start: '9:00 AM',
                end: '5:00 PM'
            }

            // Previous day.
            // const previousDay = staff.working_hours[Object.keys(staff.working_hours)[Object.keys(staff.working_hours).indexOf(day) - 1]]
            // console.log(previousDay)
            // If previous day is enabled, then use the previous day's last slot as the new slot's start time.
            // if (previousDay && previousDay.enabled) {
            //     const lastSlot = previousDay.hours[previousDay.hours.length - 1]
            //     newSlot.start = lastSlot.start
            //     newSlot.end = lastSlot.end

            // }

            staff.value.working_hours[day].hours.push(newSlot)
        }
    }
}

// Slot actions.
const removeSlot = (day, index) => {
    staff.value.working_hours[day].hours.splice(index, 1)

    if (staff.value.working_hours[day].hours.length == 0) {
        staff.value.working_hours[day].enabled = false
    }
}

const addSlot = (day) => {

    // Previous slot of the same day or previous day.
    let previousSlot = staff.value.working_hours[day].hours[staff.value.working_hours[day].hours.length - 1]
    if (!previousSlot) {
        const previousDay = staff.working_hours[Object.keys(staff.working_hours)[Object.keys(staff.working_hours).indexOf(day) - 1]]
        if (previousDay && previousDay.enabled) {
            previousSlot = previousDay.hours[previousDay.hours.length - 1]
        }
    }

    staff.value.working_hours[day].hours.push({
        start: previousSlot ? previousSlot.end : '9:00 AM',
        end: previousSlot ? moment(previousSlot.end, 'h:mm A').add(1, 'hour').format('h:mm A') : '5:00 PM'
    })
}

const updateWorkingHours = async () => {
    await save()
    isCustomSchedule.value = false
}

const additionalInfos = computed(() => {
    let staffAppointments = $appointment.getAppointments?.filter(app => app.staff_id == staff.value.staff_id) || []
    let totalAppointments = staffAppointments.length || 0
    let totalEarning = 0
    let approved = staffAppointments?.filter(app => app.meta?.status == 'approved') || []
    let pending = staffAppointments?.filter(app => app.meta?.status == 'pending') || []
    let canceled = staffAppointments?.filter(app => app.meta?.status == 'canceled') || []
    let upcoming = staffAppointments?.filter(app => moment(app.booking_date, 'YYYY-MM-DD').isAfter(new Date())) || []
    let customersId = []
    let bookingCustomers = []
    let customerRating = 'Coming Soon'

    staffAppointments.forEach(app => {
        if (!customersId.includes(app.customer_id)) customersId.push(app.customer_id)
    })

    customersId.forEach(id => {
        let customer = $customer.getCustomers?.find(c => c.customer_id == id)

        bookingCustomers.push({
            customer_id: id,
            customer_name: !customer ? 'Not Exists' : customer.name,
            profile_image: !customer ? 'https://1.gravatar.com/avatar/729ae85bf62b9917e93538db2f2688ca?s=96&d=mm&r=g' : (customer.meta?.profile_image_url || 'https://1.gravatar.com/avatar/729ae85bf62b9917e93538db2f2688ca?s=96&d=mm&r=g'),
            totalBooked: staffAppointments?.filter(app => app.customer_id == id).length
        })
    })

    approved.forEach(app => {
        totalEarning += app.meta.price
    })

    return { totalAppointments, totalEarning, approved, pending, canceled, upcoming, bookingCustomers, customerRating }
})


const isHolidayAndDayOff = ref(false)
const saveDaysOff = async () => {
    await save()
    // staff.value.days_off = []
    // console.log(staff.value.days_off)
    // await $staff.updateStaff(staff.value)
    // await $settings.saveSettings('days_off', $settings.daysOff)
    // Toast.success('Updated days off')
}
const showCustomSchedule = ref(false)
const getHolidays = computed(() => {
    if (!staff.value.days_off) return []
    let h = []
    if (staff.value.days_off && Array.isArray(staff.value.days_off) && staff.value.days_off.length) {
        staff.value.days_off.forEach((holiday, index) => {

            let date = {
                from: {
                    fullDate: holiday[0].date,
                    day: moment(holiday[0].date, 'YYYY-MM-DD').format('dddd'),
                    date: moment(holiday[0].date, 'YYYY-MM-DD').format('DD'),
                    month: moment(holiday[0].date, 'YYYY-MM-DD').format('MMMM'),
                    year: moment(holiday[0].date, 'YYYY-MM-DD').format('YYYY'),
                },
                to: {},
                time: {
                    start: moment(holiday[0].from, 'HH:mm:ss').format('h:mm A'),
                    end: moment(holiday[0].to, 'HH:mm:ss').format('h:mm A'),
                }
            }

            if (holiday[1]) {
                date.to = {
                    fullDate: holiday[1].date,
                    day: moment(holiday[1].date, 'YYYY-MM-DD').format('dddd'),
                    date: moment(holiday[1].date, 'YYYY-MM-DD').format('DD'),
                    month: moment(holiday[1].date, 'YYYY-MM-DD').format('MMMM'),
                    year: moment(holiday[1].date, 'YYYY-MM-DD').format('YYYY'),
                }
            }

            h.push(date)
        })
    }
    return h
})

const holidays = computed(() => getHolidays.value)

const customScheduleForm = ref({
    from: {},
    to: {},
    time: {
        start: {},
        end: {}
    }
})

const generateSettingsHoliday = async (method = null) => {
    if (!staff.value.days_off) staff.value.days_off = []

    if (!customScheduleForm.value.from.fullDate && method !== 'delete') return

    if (router.currentRoute.value.query.index) {
        holidays.value[router.currentRoute.value.query.index] = {
            from: customScheduleForm.value.from,
            to: customScheduleForm.value.to,
            time: customScheduleForm.value.time
        }
    } else if (!router.currentRoute.value.query.index && method !== 'delete') {
        holidays.value.push({
            from: customScheduleForm.value.from,
            to: customScheduleForm.value.to,
            time: customScheduleForm.value.time
        })
    }

    staff.value.days_off = holidays.value.map(holiday => {
        let h = []

        if (holiday.from.fullDate) {
            h.push({
                date: holiday.from.fullDate,
                from: moment(holiday.time.start, 'h:mm A').format('HH:mm:ss'),
                to: moment(holiday.time.end, 'h:mm A').format('HH:mm:ss')
            })
        }

        if (holiday.to.fullDate) {
            h.push({
                date: holiday.to.fullDate,
                from: moment(holiday.time.start, 'h:mm A').format('HH:mm:ss'),
                to: moment(holiday.time.end, 'h:mm A').format('HH:mm:ss')
            })
        }

        return h
    })
}

const addCustomSchedule = async () => {
    await generateSettingsHoliday()

    await saveDaysOff()

    let { index, ...restParams } = router.currentRoute.value.query
    router.push({
        query: { ...restParams }
    })

    showCustomSchedule.value = false
    customScheduleForm.value = {
        from: {},
        to: {},
        time: {
            start: {},
            end: {}
        }
    }
}


const getCustomScheduleInfo = (holiday) => {
    let difference = moment(holiday.to.fullDate, 'YYYY-MM-DD').diff(moment(holiday.from.fullDate, 'YYYY-MM-DD'), 'days')
    let renderDate = () => {
        let from = moment(holiday.from.fullDate, 'YYYY-MM-DD').format('DD MMM')
        let to = moment(holiday.to.fullDate, 'YYYY-MM-DD').format('DD MMM')

        if (from == to) {
            return from
        } else if (from && to == 'Invalid date') {
            return from
        } else {
            return `${from} - ${to}`
        }
    }

    return {
        difference: difference + 1 || 1,
        renderDate: renderDate()

    }
}


const editCustomSchedule = async (holiday, index) => {
    showCustomSchedule.value = true
    router.push({
        query: {
            ...router.currentRoute.value.query,
            index: index
        }
    })
    customScheduleForm.value = holidays.value[index]
}

const deleteCustomSchedule = async (holiday, index) => {
    if (index >= 0 && index < holidays.value.length) {
        holidays.value.splice(index, 1)
    } else {
        return Toast.error("Invalid index provided")
    }

    await generateSettingsHoliday('delete')
    await saveDaysOff()
}

const closeCustomeSchedule = () => {
    let { index, ...restParams } = router.currentRoute.value.query
    router.push({
        query: { ...restParams }
    })

    showCustomSchedule.value = false
}

const backButton = () => {
    console.log(route)
    if (route.query.backTo) {
        router.push(route.query.backTo)
    } else {
        router.push({ name: 'staff.list' })
    }
}
</script>

<template>
    <Modal :loading="state.loading">
        <!-- header  -->
        <template #header>
            <div class="px-8 py-6 border-b-[#EAECF0] border-b flex items-center justify-between shadow-[0px_3px_0px_0px_#eaecf0]">
                <div @click="backButton" class="cursor-pointer flex items-center gap-5 text-[#101828] text-lg font-semibold">
                    <Icon name="arrowNarrowLeft" size="24px"></Icon> Back
                </div>
            </div>
        </template>

        <template #default>
            <div class="my-[-28px] md:w-[736px] m-auto" :class="{ 'cursor-wait': state.loading }">
                <!-- profile section -->
                <div class="flex flex-col gap-6 md:flex-row mb-7">
                    <!-- profile image -->
                    <div class="w-[160px] h-[160px] m-auto md:m-0">
                        <ProfilePicture :name="staff?.display_name" :img="staff?.meta?.profile_image_url" :bgColor="staff?.meta?.color" class="w-[160px] h-[160px]" imgClass="border-4 border-[#fff] shadow-md" textClass="border-4 border-[#fff] shadow-md !text-5xl" />
                    </div>

                    <!-- profile details -->
                    <div class="w-full text-center md:text-left flex flex-col justify-center">
                        <h1 class="text-[#101828] text-2xl font-semibold">{{ staff.display_name || 'N/A' }}
                            <span class="text-[#98A2B3] text-base font-medium pl-3" v-if="staff.usid">{{ staff.usid }}</span>
                        </h1>
                        <p class="text-[#98A2B3] text-base font-medium mb-3" v-if="staff.meta.title">{{ staff.meta.title }}</p>
                        <div class="justify-center md:justify-normal flex gap-2 items-center text-[#344054] text-base font-normal mb-2">
                            <Icon name="mail01" size="20px" class="text-[#98A2B3]" />
                            {{ staff.meta?.email || 'N/A' }}
                        </div>
                        <div class="justify-center md:justify-normal flex gap-2 items-center text-[#344054] text-base font-normal mb-2">
                            <Icon name="phoneCall01" size="20px" class="text-[#98A2B3]" />
                            {{ staff.meta?.phone || 'N/A' }}
                        </div>
                        <!-- <div class="justify-center md:justify-normal flex gap-2 items-center text-[#344054] text-base font-normal mb-2">
                            <Icon name="markerPin01" size="20px" class="text-[#98A2B3]" />
                            {{ staff.meta?.address || 'N/A' }}
                        </div> -->
                    </div>

                    <!-- profile actions -->
                    <div class="flex items-end justify-center gap-3 md:justify-normal">
                        <Button v-if="access('staff.add')" size="md" type="secondary_gray" radius="square" classButton="px-[10px] h-fit" @click.prevent="deleteStaff(staff)">
                            <Icon name="trash01" size="20px" />
                        </Button>
                        <Button v-if="access('staff.add')" size="md" type="primary" radius="square" classButton="h-fit" @click.prevent="router.push({ name: 'staff.edit', params: { staffId: staff.id }, query: { backTo: route.fullPath, tab: 'profile' } })">
                            Edit
                        </Button>
                    </div>
                </div>

                <!-- profile info -->
                <div class="rounded-xl border border-[#EAECF0] p-6 mb-7">
                    <div class="flex flex-col justify-center text-center md:text-start md:gap-5 md:flex-row md:justify-normal">
                        <div class="w-full py-3">
                            <p class="text-[#475467] text-sm font-semibold mb-3 capitalize">Total {{ $settings.labels.appointment?.singular }}</p>
                            <h1 class="text-[#101828] text-3xl font-semibold">{{ additionalInfos.totalAppointments }}</h1>
                        </div>
                        <div class="w-full py-3">
                            <p class="text-[#475467] text-sm font-semibold mb-3">Total Earnings</p>
                            <h1 class="text-[#101828] text-3xl font-semibold">{{ getPrice(additionalInfos.totalEarning) }}</h1>
                        </div>
                        <div class="w-full py-3">
                            <p class="text-[#475467] text-sm font-semibold mb-3">Total Pending</p>
                            <h1 class="text-[#101828] text-3xl font-semibold">{{ additionalInfos.pending.length }}</h1>
                        </div>
                        <!-- <div class="w-full py-3">
                            <p class="text-[#475467] text-sm font-semibold mb-3">Customer rating</p>
                            <h1 class="text-[#101828] text-3xl font-semibold flex items-center gap-2 justify-center md:justify-normal">
                                <Icon name="star01" size="32px" class="text-[#F79009]" />
                                4.8<span class="text-[#667085] font-medium">(72)</span>
                            </h1>
                        </div> -->
                    </div>
                    <div class="w-full h-[1px] bg-[#EAECF0] my-3"></div>
                    <div class="flex flex-col md:gap-5 md:flex-row">
                        <div class="flex items-center justify-center w-full gap-2 py-3 md:justify-normal">
                            <p class="text-[#475467] text-sm font-semibold capitalize">{{ $settings.labels.appointment?.singular }} Completed</p>
                            <p class="text-[#101828] text-base font-semibold">{{ additionalInfos.approved.length - additionalInfos.upcoming.length }}</p>
                        </div>
                        <div class="flex items-center justify-center w-full gap-2 py-3 md:justify-normal">
                            <p class="text-[#475467] text-sm font-semibold capitalize">{{ $settings.labels.appointment?.singular }} Canceled</p>
                            <p class="text-[#101828] text-base font-semibold">{{ additionalInfos.canceled.length }}</p>
                        </div>
                        <div class="flex items-center justify-center w-full gap-2 py-3 md:justify-normal">
                            <p class="text-[#475467] text-sm font-semibold capitalize">Upcoming {{ $settings.labels.appointment?.singular }}</p>
                            <p class="text-[#101828] text-base font-semibold">{{ additionalInfos.upcoming.length }}</p>
                        </div>
                    </div>
                </div>


                <!-- profile booking service info -->
                <div class="rounded-xl border border-[#EAECF0] p-6 mb-7">
                    <h2 class="text-[#101828] text-lg font-semibold mb-5 block capitalize">Repeated {{ $settings.labels.customer?.plural }}</h2>

                    <div class="flex flex-wrap gap-3">
                        <div v-for="(customer, index) in additionalInfos.bookingCustomers" :key="index" class="flex items-center justify-between w-full md:justify-normal md:w-auto px-4 py-2.5 gap-2 rounded-[66px] border-[1.5px] border-[#EAECF0] max-w-[49%]">
                            <img :src="customer.profile_image" class="w-[24px] h-[24px] rounded-full bg-[#EAECF0]">
                            <p class="text[#344054] text-sm font-medium truncate" :title="customer.customer_name">{{ customer.customer_name || 'N/A' }}</p>
                            <div class="rounded-[10px] bg-[#F2F4F7] text-[#344054] text-sm font-medium px-1.5">{{ customer.totalBooked }}</div>
                        </div>
                        <div v-if="!additionalInfos.bookingCustomers.length" class="text-[red] text-sm font-normal">No repeat {{ String($settings.labels.customer?.plural).toLowerCase() }}</div>
                    </div>
                </div>

                <Card cardClass="gap-5">
                    <template #header>
                        <div class="flex items-center justify-between">
                            <div class="flex flex-col gap-1">
                                <div class="text-[#101828] text-lg font-semibold capitalize">Offered {{ $settings.labels.service?.plural }}</div>
                                <div class="text-[#667085] text-sm font-normal">{{ isCustomPrice ? `Choose ${String($settings.labels.service?.plural).toLowerCase()} that ${staff?.display_name} will offer to ${String($settings.labels.customer?.plural).toLowerCase()}` : `${String($settings.labels.service?.plural).toLowerCase()} that ${staff?.display_name} offers to ${String($settings.labels.customer?.plural).toLowerCase()}` }}</div>
                            </div>
                            <Button v-if="!isCustomPrice && access('staff.add')" type="primary" radius="square" size="sm" @click="isCustomPrice = !isCustomPrice">Edit</Button>
                        </div>
                    </template>
                    <div v-for="(category, index) in getCategories" :key="index" class="mb-6">
                        <div class="flex items-center gap-3 mb-[18px] ml-4">
                            <Checkbox v-if="isCustomPrice" :checked="isCatSelected(category.category_id)" @click="selectCat(category.category_id)">
                                <div class="text-[#344054] text-lg font-semibold">{{ category.name }}</div>
                            </Checkbox>
                            <div v-if="!isCustomPrice" class="text-[#344054] text-lg font-semibold">{{ category.name }}</div>

                        </div>
                        <div class="border bg-white p-4 rounded-lg border-solid border-[#D0D5DD]">
                            <div v-for="(service, index) in category.services" :key="index" :class="{ 'opacity-60  line-through': !isServiceSelected(service.service_id) }" class="h-[41px] flex gap-3 justify-between items-center text-base font-medium leading-6 pt-3 pb-3 first:pt-0 last:pb-0 border-b border-[#D0D5DD] last:border-b-0">
                                <div v-if="isCustomPrice" class="flex items-center gap-3 ml-1">
                                    <Checkbox disabled :checked="isServiceSelected(service.service_id)" @click="selectService(service.service_id)">{{ service.name }}</Checkbox>
                                </div>
                                <div v-if="!isCustomPrice">{{ service.name }}</div>
                                <!-- <Input v-else :iconLeft="$settings.payment.currency_symbol" v-model="service.price" class="w-[110px]" /> -->
                                <div class="text-[#101828] pr-3">{{ getPrice(service.price) }}</div>
                            </div>
                        </div>
                    </div>
                </Card>
                <div class="flex items-center gap-10" v-if="isCustomPrice">
                    <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] mt-10 justify-between" @click="isCustomPrice = false">
                        <div class="w-[70%]">Cancel</div>
                        <template #before>
                            <Icon name="arrowNarrowLeft" size="20px"></Icon>
                        </template>
                    </Button>
                    <Button submit size="xl" type="primary" radius="square" classButton="w-full mt-10 justify-between" @click.prevent="updateServices">
                        <div class="w-[95%]">Update</div>
                    </Button>
                </div>

                <!-- booking history -->
                <!-- <div class="rounded-xl border border-[#EAECF0] p-6 mb-7">
                    <Tabs default="service">
                        <Tab id="service">Service</Tab>s
                        <Tab id="working-hours">Working Hours</Tab>s
                        <Tab id="days-off">Days Off</Tab>s

                        <template #service>
                            <Card cardClass="gap-5">
                                <template #header>
                                    <div class="flex items-center justify-between">
                                        <div class="flex flex-col gap-1">
                                            <div class="text-[#101828] text-lg font-semibold">Offered Services</div>
                                            <div class="text-[#667085] text-sm font-normal">Assign staffs to the service and manage commission</div>
                                        </div>
                                        <Button v-if="!isCustomPrice" type="primary" radius="square" size="sm" @click="isCustomPrice = !isCustomPrice">Edit</Button>
                                    </div>
                                </template>
<div v-for="(category, index) in getCategories" :key="index" class="mb-6">
    <div class="flex items-center gap-3 mb-[18px] ml-4">
        <Checkbox v-if="isCustomPrice" :checked="isCatSelected(category.category_id)" @click="selectCat(category.category_id)">
            <div class="text-[#344054] text-lg font-semibold">{{ category.name }}</div>
        </Checkbox>
        <div v-if="!isCustomPrice" class="text-[#344054] text-lg font-semibold">{{ category.name }}</div>

    </div>
    <div class="border bg-white p-4 rounded-lg border-solid border-[#D0D5DD]">
        <div v-for="(service, index) in category.services" :key="index" :class="{ 'opacity-60  line-through': !isServiceSelected(service.service_id) }" class="h-[41px] flex gap-3 justify-between items-center text-base font-medium leading-6 pt-3 pb-3 first:pt-0 last:pb-0 border-b border-[#D0D5DD] last:border-b-0">
            <div v-if="isCustomPrice" class="flex items-center gap-3 ml-1">
                <Checkbox disabled :checked="isServiceSelected(service.service_id)" @click="selectService(service.service_id)">{{ service.name }}</Checkbox>
            </div>
            <div v-if="!isCustomPrice">{{ service.name }}</div>
            <Input v-else :iconLeft="$settings.payment.currency_symbol" v-model="service.price" class="w-[110px]" />
            <div class="text-[#101828] pr-3">{{ getPrice(service.price) }}</div>
        </div>
    </div>
</div>
</Card>
<div class="flex items-center gap-10" v-if="isCustomPrice">
    <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] mt-10 justify-between" @click="isCustomPrice = false">
        <div class="w-[70%]">Cancel</div>
        <template #before>
                                        <Icon name="arrowNarrowLeft" size="20px"></Icon>
                                    </template>
    </Button>
    <Button submit size="xl" type="primary" radius="square" classButton="w-full mt-10 justify-between" @click.prevent="updateServices">
        <div class="w-[95%]">Update</div>
    </Button>
</div>
</template>

<template #working-hours>
                            <Card cardClass="gap-5">
                                <template #header>
                                    <div class="flex items-center justify-between">
                                        <div class="flex flex-col gap-1">
                                            <div class="text-[#101828] text-lg font-semibold">Working Hours</div>
                                            <div class="text-[#667085] text-sm font-normal">Staff members assigned time for service</div>
                                        </div>
                                        <Button v-if="!isCustomSchedule" type="primary" radius="square" size="sm" @click="isCustomSchedule = !isCustomSchedule">Edit</Button>
                                    </div>
                                </template>
<template #default>
                                    <Card cardClass="gap-5 mb-5 !p-4">
                                        <div class="flex flex-col gap-3">
                                            <div v-for="(schedules, day) in  staff.working_hours " :key="index" class="flex items-start justify-between gap-10 transition-all pb-3 border-b last:border-b-0 border-b-[#D0D5DD]">
                                                <Toggle v-if="isCustomSchedule" @click="toggleSchedule(day)" :checked="isScheduleEnabled(schedules.enabled)" class="w-[220px] mt-3">{{ day }}</Toggle>
                                                <div v-if="!isCustomSchedule">{{ day }}</div>

                                                <div v-if="!isScheduleEnabled(schedules.enabled)" class="w-[284px] text-[#98A2B3] text-base font-medium h-[41px] flex items-center" :class="{ 'justify-end': !isCustomSchedule }">Unavailable</div>
                                                <div v-else class="flex w-full gap-2" :class="!isCustomSchedule ? 'justify-end' : ' justify-between'">
                                                    <div class="flex flex-col gap-3">

                                                        <div v-if="schedules.hours" v-for="( slot, index ) in  schedules.hours " :key="index" class="flex items-center gap-3 w-[284px]" :class="{ 'justify-end pointer-events-none': !isCustomSchedule }">

                                                            <TimePicker v-model="slot.start" class="w-[110px]" placeholder="From" format="12" />
                                                            -
                                                            <TimePicker @click.prevent v-model="slot.end" class="w-[110px]" placeholder="To" format="12" />

                                                            <Icon v-if="isCustomSchedule" @click="removeSlot(day, index)" name="trash01" size="20px" class="text-[#667085] hover:text-[#2b2c30] cursor-pointer" />
                                                        </div>
                                                        <div v-else class="flex items-center h-full">
                                                            <Button size="xs" type="secondary_color" @click="schedules.hours = schedules.hours || [], schedules.hours.push({ start: '', end: '' })">
                                                                <Icon name="plus" />Add first slot
                                                            </Button>
                                                        </div>
                                                    </div>
                                                    <Icon v-if="isCustomSchedule" @click="addSlot(day)" name="plus" size="20px" class="text-[#667085] hover:text-[#2b2c30] cursor-pointer mt-3" />
                                                </div>

                                            </div>
                                        </div>
                                    </Card>
                                    <div class="flex items-center gap-10" v-if="isCustomSchedule">
                                        <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] justify-between" @click="isCustomSchedule = false">
                                            <div class="w-[70%]">Cancel</div>
                                            <template #before>
                                                <Icon name="arrowNarrowLeft" size="20px"></Icon>
                                            </template>
</Button>
<Button submit size="xl" type="primary" radius="square" classButton="w-full justify-between" @click.prevent="updateWorkingHours">
    <div class="w-[95%]">Update</div>
</Button>
</div>
</template>
</Card>


</template>
<template #days-off>
                            <div class="flex items-center justify-between">
                                <div class="flex flex-col gap-1">
                                    <div class="text-[#101828] text-lg font-semibold">Holidays & Days Off</div>
                                    <div class="text-[#667085] text-sm font-normal">Assign staffs to the service and manage commission</div>
                                </div>
                            </div>
                            <div class="flex flex-col gap-5 md:flex-row md:flex-wrap mt-7">
                                <div v-for="(holiday, index) in holidays" class="relative p-[6px_8px_8px_8px] border border-[#D0D5DD] rounded-lg w-full md:w-[156px] text-center">
                                    <Dropdown contentClass="top-[30px] w-[117px]">
                                        <Icon name="dotsVertical" size="36px" class="text-[#98A2B3] p-2 absolute top-0 left-[-5px] cursor-pointer"></Icon>

                                        <template #content>
                                            <div class="flex flex-col gap-1">
                                                <div class=" rounded-md mx-1.5 my-0.5 transition">
                                                    <div @click="editCustomSchedule(holiday, index)" class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
                                                        <Icon size="16px" name="edit05" />
                                                        <div class="text-[#344054] text-sm font-medium">Edit</div>
                                                    </div>
                                                    <div @click="deleteCustomSchedule(holiday, index)" class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
                                                        <Icon size="16px" name="trash01" />
                                                        <div class="text-[#344054] text-sm font-medium">Delete</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
</Dropdown>
<div class="text-[#7F56D9] text-4xl font-semibold leading-normal mt-[12px]">{{ getCustomScheduleInfo(holiday).difference }}</div>
<div class="text-[#667085] text-sm font-normal ">{{ getCustomScheduleInfo(holiday).difference > 1 ? 'Days' : 'Day' }}</div>
<div class="text-[#667085] text-xs font-medium py-2 px-3 mt-6 bg-[#F2F4F7] rounded">{{ getCustomScheduleInfo(holiday).renderDate }}</div>
</div>
<div @click="showCustomSchedule = true" class="min-h-[160px] cursor-pointer p-[6px_8px_8px_8px] border border-dashed border-[#D0D5DD] rounded-lg w-full md:w-[156px] flex flex-col items-center justify-center">
    <Icon name="plus" size="40px" class="p-1.5 text-[#98A2B3] rounded-full border-2 border-dashed border-[#D0D5DD]"></Icon>
    <div class="text-[#667085] text-sm font-normal mt-4">Add day</div>
</div>
</div>

<Modal class="z-[100]" style="position:fixed !important;" v-if="showCustomSchedule">
    <template #header>
                                    <div @click="closeCustomeSchedule()" class="px-8 py-6 border-b-[#EAECF0] border-b flex items-center justify-between">
                                        <div class="flex items-center gap-5 text-[#101828] text-lg font-semibold">
                                            <Icon name="arrowNarrowLeft" size="24px"></Icon> Back
                                        </div>
                                    </div>
                                </template>
    <template #default>
                                    <CustomSchedule v-model="customScheduleForm" class="mt-5" />

                                    <div class="md:w-[736px] m-auto flex flex-col md:flex-row items-center gap-2 md:gap-10">
                                        <Button @click.prevent="closeCustomeSchedule()" size="xl" type="secondary_gray" radius="square" classButton="w-full md:!w-[180px] md:mt-10 justify-between">
                                            <div class="w-[70%]">Cancel</div>
                                            <template #before>
                                                <Icon name="arrowNarrowLeft" size="20px"></Icon>
                                            </template>
    </Button>
    <Button @click.prevent="addCustomSchedule()" :disabled="!customScheduleForm.from.fullDate" submit size="xl" type="primary" radius="square" classButton="w-full md:mt-10 justify-between">
        <div class="w-[95%]">Save Schedule</div>
    </Button>
    </div>
    </template>
</Modal>

</template>
</Tabs>
</div> -->
            </div>
        </template>
    </Modal>
</template>
